import { Form, Input, message, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { GetCountries } from "../../../../API/endpoints/Common";
import { removeDuplicatesByValue } from "../../../../API/axios";
import { validateEmail } from "../../../../common/validators";
import { addTeamMember, updateTeamMember } from "../../../../API/endpoints/User";

interface Props {
    open: boolean;
    editData?: any;
    orgId?: string;
    onCancel: () => void;
    onSuccess: () => void;
}
const AddEditTeamMemberModal = (props: Props) => {
    const { editData, open, onSuccess, orgId } = props;

    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const [submitLoading, setSubmitLoading] = useState(false);
    const [countryList, setCountryList] = useState<any[]>([])

    useEffect(() => {
        GetCountries().then((res: any) => {
            setCountryList(removeDuplicatesByValue(res?.data || [], "country_code"))
        })
    }, [])


    useEffect(() => {
        if (editData && Object.keys(editData).length > 0) {
            form.setFieldsValue({
                first_name: editData?.first_name,
                last_name: editData?.last_name || undefined,
                email_id: editData?.email_id,
                contact_number_code: editData?.contact_number_code,
                contact_number: editData?.contact_number,
                designation: editData?.designation,
            })
        }
    }, [editData])

    const onSubmit = () => {
        form.validateFields().then((values: any) => {
            setSubmitLoading(true);
            const req = {
                org_id: orgId,
                first_name: values?.first_name,
                last_name: values?.last_name || undefined,
                email_id: values?.email_id,
                contact_number_code: values?.contact_number_code,
                contact_number: values?.contact_number,
                designation: values?.designation,
                user_type: "organization",
                role: ["4"]
            }

            if (editData && Object.keys(editData).length > 0) {
                updateTeamMember(editData?.id, req).then((res: any) => {
                    onSuccess()
                    form.resetFields()
                    setSubmitLoading(false);
                }).catch((err) => {
                    console.error('err', err);
                    messageApi.error("Failed to update team member");
                    setSubmitLoading(false);
                })
            } else {
                addTeamMember(req).then((res: any) => {
                    onSuccess()
                    form.resetFields()
                    setSubmitLoading(false);
                }).catch((err) => {
                    console.error('err', err);

                    messageApi.error("Failed to add team member");
                    setSubmitLoading(false);
                })
            }

        })
    }

    const onCancel = () => {
        props?.onCancel();
        form.resetFields()
    }


    return (
        <Modal
            width={500}
            open={open}
            onCancel={() => onCancel()}
            classNames={{
                content: "!p-0 h-[calc(100vh-40px)] flex flex-col",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0 bg-white",
                body: "!px-[20px] !py-[12px] bg-[#F9FAFB] flex-1",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            className="h-[calc(100% - 40px)] top-[20px] right-[20px] absolute pb-0"
            title={(
                <p className="m-0 font-[500] text-[14px]">
                    {editData && Object.keys(editData).length > 0 ? "Edit" : "Add New"} Team Member
                </p>
            )}
            okText={editData && Object.keys(editData).length > 0 ? "Save" : "invite"}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
            okButtonProps={{
                loading: submitLoading
            }}
            onOk={() => onSubmit()}
        >
            {contextHolder}
            <Form layout="vertical" requiredMark={false} form={form}>
                <div className="grid grid-cols-2 gap-[16px]">
                    <Form.Item
                        name="first_name"
                        label="First Name"
                        rules={[{ required: true }]}
                    >
                        <Input
                            type="text" />
                    </Form.Item>
                    <Form.Item
                        name="last_name"
                        label="Last Name"
                    >
                        <Input
                            type="text" />
                    </Form.Item>
                    <Form.Item
                        name="designation"
                        label="Designation"
                        rules={[{ required: true }]}
                    >
                        <Input
                            type="text" />
                    </Form.Item>
                    <Form.Item
                        name="email_id"
                        label="Email"
                        rules={[{ required: true }, validateEmail]}
                    >
                        <Input
                            type="email" />
                    </Form.Item>
                    <Form.Item
                        name="contact_number"
                        label="Phone"
                        rules={[{ required: true }, ({ getFieldValue }) => ({
                            validator(_, value) {
                                const phonePattern = /^\d{6,14}$/;
                                const phoneCode = getFieldValue("contact_number_code");
                                return !value || phonePattern.test(value)
                                    ? phoneCode && !value ? Promise.reject(new Error("Enter Phone Number")) : Promise.resolve()
                                    : Promise.reject(new Error("Invalid Phone Number"))
                            }
                        })]}
                    >
                        <Input
                            addonBefore={(
                                <Form.Item
                                    name={"contact_number_code"}
                                    noStyle
                                    dependencies={["contact_number"]}
                                    rules={[{ required: true, message: "enter code!" }]}
                                >
                                    <Select style={{ width: 90 }}
                                        options={countryList}
                                        placeholder="+00"
                                        showSearch
                                        fieldNames={{ label: "country_code", value: "country_code" }}
                                    >
                                    </Select>
                                </Form.Item>
                            )}
                            placeholder=""
                        />
                    </Form.Item>
                </div>
            </Form>

        </Modal>
    )
}

export default AddEditTeamMemberModal